// extracted by mini-css-extract-plugin
export default {"layout":"Is87rC","title":"LhOrUq","hide":"MrbyQV","description":"uE6IB9"};